import * as React from 'react';

export default () => {
	return (
		<div className="tree-empty"><span>No Equipment Costs available</span></div>
	);
};
